import Model from '@/class/cargo/model/utils/Model'
export class TransportType {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}
export const CODE_NAME = 'TransportType'

export const LINE_TRANSPORT = new TransportType('LINE_TRANSPORT', '班列运输', 'Line Transport')
export const DOMESTIC_TRANSPORT = new TransportType('DOMESTIC_TRANSPORT', '国内运输', 'Domestic Transport')
export const FULL_TRANSPORT = new TransportType('FULL_TRANSPORT', '国联全程', 'Full Transport')
export const HALF_TRANSPORT = new TransportType('HALF_TRANSPORT', '国联半程', 'Half Transport')
export const FULL_TRANSIT = new TransportType('FULL_TRANSIT', '过境全程', 'Full Transit')
export const HALF_TRANSIT = new TransportType('HALF_TRANSIT', '过境半程', 'Half Transit')
export const SEARAIL_TRANSPORT = new TransportType('SEARAIL_TRANSPORT', '海铁联运', 'Sea Rail Transport')
export const RAILWAY_TRANSPORT = new TransportType('RAILWAY_TRANSPORT', '铁路联运', 'Railway Transport')

export const TYPES = [LINE_TRANSPORT, DOMESTIC_TRANSPORT, FULL_TRANSPORT, HALF_TRANSPORT, FULL_TRANSIT, HALF_TRANSIT, SEARAIL_TRANSPORT, RAILWAY_TRANSPORT]

/**
		 *  return null:没找到.
		 */
export function getTransportTypeByCode(code) {
  return Model.getObjByCode(code, TYPES)
}

/**
		 *  return null:没找到.
		 */
export function getTransportTypeByBusType(code, arrs) {
  return Model.getObjByCode(code, arrs)
}
